import { render } from "./CommentCard.vue?vue&type=template&id=316b2076&scoped=true"
import script from "./CommentCard.vue?vue&type=script&lang=js"
export * from "./CommentCard.vue?vue&type=script&lang=js"

import "./CommentCard.vue?vue&type=style&index=0&id=316b2076&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316b2076"]])

export default __exports__